import React from "react";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";
import { LogOut, Wrench } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { ROLE_LABELS } from "../../lib/gmaoConstants";
import { companyInfo } from "../../data/mock";
import RobotsTag from "../seo/RobotsTag";
import { Button } from "../ui/button";
import { Badge } from "../ui/badge";

const GmaoLayout = ({ children }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/login", { replace: true });
  };

  return (
    <div className="min-h-screen bg-slate-50">
      {/* SEO : espace privé non indexé */}
      <RobotsTag content="noindex, nofollow" />
      <Helmet>
        <title>Espace GMAO – NGL SERVICES</title>
      </Helmet>

      <header className="bg-[hsl(215,25%,15%)] text-white sticky top-0 z-40 shadow-md">
        <div className="max-w-7xl mx-auto px-4 h-16 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="bg-[hsl(207,78%,42%)] rounded-lg p-2">
              <Wrench className="w-5 h-5 text-white" />
            </div>
            <div className="leading-tight">
              <p className="font-bold text-sm sm:text-base">{companyInfo?.name || "NGL SERVICES"}</p>
              <p className="text-[11px] sm:text-xs text-slate-300">Portail Interventions · GMAO</p>
            </div>
          </div>

          <div className="flex items-center gap-3">
            {user && user !== false && (
              <div className="text-right hidden sm:block">
                <p className="text-sm font-medium" data-testid="gmao-user-name">{user.name}</p>
                <Badge variant="outline" className="text-[10px] border-slate-500 text-slate-200">
                  {ROLE_LABELS[user.role] || user.role}
                </Badge>
              </div>
            )}
            <Button
              variant="ghost"
              size="sm"
              onClick={handleLogout}
              className="text-slate-200 hover:text-white hover:bg-white/10"
              data-testid="logout-button"
            >
              <LogOut className="w-4 h-4 sm:mr-2" />
              <span className="hidden sm:inline">Déconnexion</span>
            </Button>
          </div>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-4 py-6 sm:py-8">{children}</main>
    </div>
  );
};

export default GmaoLayout;
